export default "__VITE_ASSET__DaQcltcj__"